import { Observable } from '@code-expert/fp-ts-rxjs';
import { constant, identity, increment, tagged } from '@code-expert/prelude';
const pubsubEventAdt = tagged.build();
const triggerReducer = pubsubEventAdt.fold({
    ready: constant(identity),
    trigger: constant(increment),
    initial: constant(increment),
    insert: constant(increment),
    update: constant(increment),
    delete: constant(increment),
    count: constant(increment),
});
export const aggregateTrigger = () => (source) => new Observable((subscriber) => {
    let state = 0;
    return source.subscribe({
        complete: () => {
            subscriber.complete();
        },
        error: (e) => {
            subscriber.error(e);
        },
        next: (event) => {
            state = triggerReducer(event)(state);
            subscriber.next(state);
        },
    });
});
//# sourceMappingURL=Trigger.js.map